import { render } from "./TraceComponent.vue?vue&type=template&id=004c3c74"
import script from "./TraceComponent.vue?vue&type=script&lang=js"
export * from "./TraceComponent.vue?vue&type=script&lang=js"

import "./TraceComponent.vue?vue&type=style&index=0&id=004c3c74&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__